import axios from "axios";
import jwt from "jwt-decode";
import { setToken } from "../interceptors/tokenStore";

class AuthService {
  login = (formdata) => {
    try {
      return axios({
        method: "post",
        url: `/login`,
        data: formdata,
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        if (response.data.status === 200) {
          axios.defaults.headers.common["Authorization"] =
            response.data.accessToken;
          localStorage.setItem("refreshToken", response.data.refreshToken);
          const user_role = jwt(response.data.refreshToken);
          localStorage.setItem("user_role", user_role.role);
          setToken(response.data.accessToken);
        }
        return response.data;
      });
    } catch (error) {
      console.log(error);
    }
  };
  logout = async (formdata) => {
    return axios({
      method: "post",
      url: `/logout`,
      data: formdata,
      withCredentials: true,
    }).then((response) => {
      if (response.data.status === 200) {
        localStorage.clear();
      }
      return response.data;
    });
  };
  getCurrentUser() {
    return localStorage.getItem("refreshToken");
  }

  ChangeRoleToken = async (formdata) => {
    try {
      return axios({
        method: "post",
        url: `/change-role-token`,
        data: formdata,
        withCredentials: true,
      }).then((response) => {
        if (response.data.status === 200) {
          axios.defaults.headers.common["Authorization"] =
            response.data.accessToken;
          localStorage.setItem("refreshToken", response.data.refreshToken);
          const user_role = jwt(response.data.refreshToken);
          localStorage.setItem("user_role", user_role.role);
        }
        return response.data;
      });
    } catch (error) {
      console.log(error);
    }
  };

  LogOutAllUsers = async (formdata) => {
    try {
      return axios({
        method: "post",
        url: `/users/logout-all-users`,
        data: formdata,
        withCredentials: true,
      }).then((response) => {
        return response.data;
      });
    } catch (error) {
      console.log(error);
    }
  };

  UploadDocument = (formData) => {
    return axios({
      method: "post",
      url: `/subscriptions/upload-adadhar-pan-details`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  readDateWiseLogs = (formData) => {
    return axios({
      method: "post",
      url: `/read-date-wise-log`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  //testing
  // login() {
  //   return axios
  //     .get(API_URL+"jwt")
  //     .then(response => {
  //       if (response.data.accessToken) {
  //         localStorage.setItem("user", JSON.stringify(response.data));
  //       }
  //       return response.data;
  //     });
  // }
  // logout() {
  //   localStorage.removeItem("user");
  // }
  // register(username, email, password) {
  //   return axios.post(API_URL + "signup", {
  //     username,
  //     email,
  //     password
  //   });
  // }
  // getCurrentUser() {
  //   return JSON.parse(localStorage.getItem('user'));
  // }
}
export default new AuthService();
